import "../styles.scss";

import moment from "moment";
import { useTranslation } from "react-i18next";

import PlaceholderText from "../../../../components/Placeholder/PlaceholderText";

function TableLogPush({ allLog = [], setDetailLog }) {
  const { t } = useTranslation();

  return (
    <div className="bigBoxTable">
      <button type="button" className="buttonBack" onClick={() => setDetailLog(false)}>
        {t("BACK")}
      </button>

      {allLog.length > 0 ? (
        <table>
          <tbody>
            <tr>
              <th>{t("TITLE")}</th>
              <th>{t("CONTENT")}</th>
              <th>{t("GROUP")}</th>
              <th>Specific Filter</th>
              <th>{t("DATE")}</th>
            </tr>

            {allLog.map((item) => (
              <tr key={item.id}>
                <td>{item.pushtoolMessage.titleEn}</td>
                <td>{item.pushtoolMessage.messageEn.slice(0, 25) + "..."}</td>
                <td>{item.group}</td>
                <td>{item.specificFilter ? item.specificFilter : "-"}</td>
                <td>{moment(item.createdAt).format("YYYY-MM-DD h:mm:ss")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        allLog.length === 0 && <PlaceholderText pageName="users" textMsg="No results" />
      )}
    </div>
  );
}

export default TableLogPush;
